import React from "react";
import { useAtom } from "jotai";
import FinanceDetailV2 from "../FinanceDetailV2";
import { financeDirtyAtom } from "../hooks/useFinanceDetail";

// Modale plein écran montant la page financement en mode embedded :
// le devis ouvert dessous n'est pas altéré (FinanceV2 ne touche plus
// à state.quotation) et la fermeture déclenche le cleanup resetFinance.
const FinanceModalV2 = ({ devisUuid, clientUuid, reference, onClose }) => {
  const [isDirty] = useAtom(financeDirtyAtom);

  // Garde de sortie : ne pas perdre une saisie non enregistrée par un clic
  // hors modale ou sur « Fermer ».
  const requestClose = () => {
    if (
      isDirty &&
      !window.confirm(
        "Vous avez des modifications non enregistrées. Fermer sans enregistrer ?",
      )
    ) {
      return;
    }
    onClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.5)",
        zIndex: 1050,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) requestClose();
      }}
    >
      <div
        style={{
          position: "relative",
          width: "95%",
          height: "95%",
          background: "#f5f6fa",
          borderRadius: 8,
          boxShadow: "0 1rem 3rem rgba(0, 0, 0, 0.3)",
          overflowY: "auto",
          padding: 16,
        }}
      >
        <button
          type="button"
          className="btn btn-default btn-sm"
          style={{ position: "sticky", top: 0, float: "right", zIndex: 2 }}
          onClick={requestClose}
          title="Fermer et revenir au devis"
        >
          <i className="fa fa-times mr-1" />
          Fermer
        </button>
        <FinanceDetailV2
          embedded
          devisUuid={devisUuid}
          clientUuid={clientUuid}
          reference={reference}
        />
      </div>
    </div>
  );
};

export default FinanceModalV2;
